import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

const InfoFilledIcon = (props: IconProps) => (
  <Icon viewBox="0 0 20 20" boxSize={5} {...props}>
    <path
      d="M10 1.66666C5.4 1.66666 1.66667 5.39999 1.66667 9.99999C1.66667 14.6 5.4 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99999C18.3333 5.39999 14.6 1.66666 10 1.66666ZM10.8333 14.1667H9.16667V9.16666H10.8333V14.1667ZM10.8333 7.49999H9.16667V5.83332H10.8333V7.49999Z"
      fill="currentColor"
    />
  </Icon>
);

export default InfoFilledIcon;
